<template>
    <div class="multi-select question-options">
        <button v-for="option in options" :key="option"
            class="option" :class="{selected : properties[option]}"
            @click.prevent="clickOption(option)"
        >
            <span class="option--icon" :class="option"></span>
            <label class="option--label">{{$t('appointment_edit.label_'+option)}}</label>
        </button>
    </div>
</template>

<script>
export default {
    name : "ClientMultiSelect",
    props: {
        client : {
            type : Object
        },
        options: {
            type: Array
        }
    },

    computed: {
        properties() {
            return this.client.additional_info.extras || {};
        }
    },

    methods: {
        clickOption(option) {
            const client = this.client;
            const properties = client.additional_info.extras || {};
            if (properties[option] === true) {
                delete(properties[option]);
            } else {
                properties[option] = true;
            }

            client.additional_info.extras = properties;
            this.$emit("update:client", client);
            this.$forceUpdate();
        }
    }
};
</script>

<style lang="scss" scoped>
    .multi-select.question-options {
        margin: auto;
        max-width: 55rem;
        align-content: space-between;
        flex-wrap: wrap;
        height : 53vh;
        margin-top : 1.5rem;

        .option {
            width: 22vh;
            height: 22vh;

            &--label {
                top : 8.8em;
            }

            &--icon {
                width: 3.5rem;
                height: 3.5rem;
            }
        }
    }
</style>
